module.exports = __webpack_public_path__ + "static/media/02.e6299b29.jpg";